const route = {
	path: ':idPlan/:codePlan-:namePlan/edit',
	name: 'page-edit-plan',
	meta: {
		title: 'Editar Plan',
	},
	props: true,
	component: () => import('@/pages/plans/page-plan-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/plans-edit.js